// @ts-nocheck
import { Plugin } from '/data/data.akualku/.jenkins/workspace/test-ec-mobile-openpay/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu',],
});

export { plugin };
